import React, { CSSProperties, useEffect, useState } from 'react';
import styled from 'styled-components';
import { motion, useMotionValueEvent, useTransform } from 'motion/react';
import { useLocation, useNavigate } from 'react-router-dom';
import ReactGA from 'react-ga4';
import { Menu, MenuType } from '../menu';
import { useMobile } from '../hook/usePlatform';
import {
  FontWeightType, LabelLarge, LabelMedium, LabelSmall,
} from './Text';
import ResponsivePaddingWrapper from './responsive/responsivePaddingWrapper';

export interface NavBarType {
  progress: any,
  // eslint-disable-next-line react/no-unused-prop-types
  rootRef: any,
}

const NavBar: React.FC<NavBarType> = (props: NavBarType) => {
  const navBarList = Menu;
  const borderBottom = '1px solid #979593';
  const navigate = useNavigate();
  const [currentRoute, setCurrentRoute] = useState<string | null>(null);
  const location = useLocation();
  const backgroundColor = useTransform(props.progress, [0, 0.1], ['#ffffff00', '#F9F4EF']);
  const borderColor = useTransform(props.progress, [0, 0.1], ['#ffffff00', '#979593']);
  const fontColor = useTransform(props.progress, [0, 0.1], ['#ffffff', '#000000']);
  const opacity = useTransform(props.progress, [0, 0.1], [1, 0]);
  const isMobile = useMobile();
  const [sticky, setStick] = useState(false);
  useMotionValueEvent(props.progress, 'change', (late: number) => {
    if (late > 0.035) {
      setStick(true);
    } else if (sticky) {
      setStick(false);
    }
  });
  const isHome = location.pathname.replace(/\//g, '') === '';
  useEffect(() => {
    setCurrentRoute(location.pathname);
    ReactGA.event({
      category: 'page',
      label: location.pathname,
      action: 'page_change',
    });
  }, [location]);
  if (window.location.pathname === '/') {
    return null;
  }
  return (
    <motion.div
      style={{
        position: !isHome ? 'relative' : 'fixed',
        top: 0,
        backgroundColor: (!isHome) ? '#F9F4EF' : backgroundColor,
        color: (!isHome) ? '#000000' : fontColor,
        zIndex: 999,
        width: '100vw',
      }}
    >
      <motion.div
        style={{
          overflow: 'hidden',
          borderBottom,
          borderColor,
        }}
      >
        <ResponsivePaddingWrapper
          style={{
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            width: '100%',
            alignItems: isMobile ? '' : 'center',
          }}
        >

          <div
            style={{
              cursor: 'pointer',
              display: 'flex',

              paddingTop: 16,
              paddingBlock: 8,
              paddingInlineStart: isMobile ? 16 : 0,
            }}
            onClick={() => {
              navigate('/#')?.catch(() => {
              });
            }}
          >
            <div style={{ position: 'relative' }}>
              <img src="/image/logo.png" height={isMobile ? 30 : 50} alt="시럽 인연" />
              <motion.div
                style={{
                  position: 'absolute', opacity: (!isHome) ? 0 : opacity, top: 0,
                }}
              >
                <img src="/image/logo_white.png" height={isMobile ? 30 : 50} alt="시럽 인연" />
              </motion.div>
            </div>
            {isMobile ? (
              <CallButton style={{
                flex: 1,
                paddingBlock: 0,
                paddingInlineEnd: 16,
              }}
              />
            ) : null}
          </div>

          <div style={{
            display: 'flex',
            flex: 1,
            justifyContent: 'space-around',
            paddingInline: isMobile ? 0 : 16,
            borderBlock: isMobile ? borderBottom : '',
          }}
          >
            {navBarList.map((e) => (
              <MenuTitle
                key={`route_menu_${e.key}`}
                menuItem={e}
                title={e.name}
                selected={currentRoute === e.key}
              />
            ))}

          </div>
          {!isMobile ? <CallButton /> : null}
        </ResponsivePaddingWrapper>
      </motion.div>
    </motion.div>
  );
};
interface MenuTileProps {
  style?:CSSProperties,
  selected:boolean;
  title:string;
  menuItem: MenuType
}
const MenuTitle:React.FC<MenuTileProps> = (props) => {
  const {
    style = {},
    selected = false,
    title = '',
    menuItem,
  } = props;
  const isMobile = useMobile();
  const styled = selected ? { fontWeight: 'bold', borderBottom: isMobile ? '' : '2px solid #333333' } : {};
  return (
    <NavMenu
      style={{
        paddingBlock: 16,
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'center',
        ...style,
      }}
      onClick={() => {
        window.location.href = menuItem.isPage ? `/${menuItem.key}` : `/#${menuItem.key}`;
      }}
    >
      <LabelLarge style={{ fontFamily: 'inter', textAlign: 'center', ...styled }}>
        {title}
      </LabelLarge>
    </NavMenu>
  );
};
const CallButton = (props:{ style?:CSSProperties, }) => (
  <NavMenu
    style={{
      paddingBlock: 16,
      cursor: 'pointer',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
      ...props.style,
    }}
    onClick={() => {
      window.location.href = 'tel:02-508-5670';
    }}
  >
    <LabelSmall style={{ fontFamily: 'inter', textAlign: 'center' }} fontWeight={FontWeightType.w700}>
      무료 상담 전화
    </LabelSmall>
    <LabelMedium style={{ fontFamily: 'inter', textAlign: 'center' }} fontWeight={FontWeightType.w700}>
      02-508-5670
    </LabelMedium>
  </NavMenu>
);

const NavMenu = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;


    &:hover {
        font-weight: bold;
    }
`;

export default NavBar;
